import { Category, Product, SpecificProduct } from '@ucx-js/chat-ui';

const departmentIdKey = 'departmentId';
const platformKey = 'platform';

function createCategory(item, categoriesMap: Map<string, Category>): void {
  if (!categoriesMap.has(item['curation1'])) {
    const category: Category = {
      title: item['curation1'],
      icon: item['curation1Icon'],
      products: [],
      description: item['curation1Description']
        ? item['curation1Description']
        : '',
      departmentId: item[departmentIdKey],
      platform: item[platformKey],
      aaEligible: item['agentAssistFlag'],
    };
    categoriesMap.set(category.title, category);
  }
}

function createProduct(item, categoriesMap: Map<string, Category>): void {
  const category = categoriesMap.get(item['curation1']);
  const existingProduct = category.products.find(
    (p) => p.title === item['curation2']
  );
  if (category && !existingProduct) {
    const product: Product = {
      title: item['curation2'],
      icon: item['curation2Icon'],
      specificProducts: [],
      description: item['curation2Description']
        ? item['curation2Description']
        : '',
      departmentId: item[departmentIdKey],
      platform: item[platformKey],
      aaEligible: item['agentAssistFlag'],
    };
    category.products.push(product);
    categoriesMap.set(category.title, category);
  }
}

function createSpecificProduct(
  item,
  categoriesMap: Map<string, Category>
): void {
  const category = categoriesMap.get(item['curation1']);
  const product = category.products.find((p) => p.title === item['curation2']);
  if (category && product) {
    const specificProduct: SpecificProduct = {
      title: item['curation3'],
      icon: item['curation3Icon'],
      description: item['curation3Description'],
      departmentId: item[departmentIdKey],
      platform: item[platformKey],
      aaEligible: item['agentAssistFlag'],
    };

    product.specificProducts.push(specificProduct);
    categoriesMap.set(category.title, category);
  }
}

export function preparePostEscalationMenuItems(curationList: []): Category[] {
  const categoriesMap = new Map<string, Category>();

  const curationListWithDepartmentIds = curationList.filter(
    (item) => !!item[departmentIdKey]
  );

  curationListWithDepartmentIds
    .filter((item) => item['curation1'])
    .forEach((item) => createCategory(item, categoriesMap));

  curationListWithDepartmentIds
    .filter((item) => item['curation2'])
    .forEach((item) => createProduct(item, categoriesMap));

  curationListWithDepartmentIds
    .filter((item) => item['curation3'])
    .forEach((item) => createSpecificProduct(item, categoriesMap));

  return Array.from(categoriesMap.values());
}
